import React from "react";
import { useTranslation } from "react-i18next";

export const LanguageToggle = ({ className = "" }) => {
  const { i18n } = useTranslation();
  const current = (i18n.language || "en").slice(0, 2);

  const set = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className={`flex items-center gap-0 text-xs uppercase tracking-widest ${className}`} data-testid="lang-toggle">
      <button
        onClick={() => set("en")}
        className={`px-2 py-1 transition-colors ${current === "en" ? "text-olive font-semibold" : "text-ink-muted hover:text-ink"}`}
        data-testid="lang-en"
        aria-label="English"
      >
        EN
      </button>
      <span className="text-edge">/</span>
      <button
        onClick={() => set("hr")}
        className={`px-2 py-1 transition-colors ${current === "hr" ? "text-olive font-semibold" : "text-ink-muted hover:text-ink"}`}
        data-testid="lang-hr"
        aria-label="Hrvatski"
      >
        HR
      </button>
    </div>
  );
};
